import { Helmet } from 'react-helmet';

const Metatags = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='author' content='Sealabs' />
    </Helmet>
  );
};
export default Metatags;
